// Define an interface for the function that includes an optional canvas property.
interface MeasureTextWidthFn {
  (text: string, font: string): number;
  canvas?: HTMLCanvasElement;
}

export const measureTextWidth: MeasureTextWidthFn = (
  text: string,
  font: string
): number => {
  // Reuse a canvas element stored on the function if available,
  // otherwise create a new one and assign it to the function.
  const canvas =
    measureTextWidth.canvas ||
    (measureTextWidth.canvas = document.createElement('canvas'));
  const context = canvas.getContext('2d');
  if (!context) {
    return 0;
  }
  context.font = font;
  return context.measureText(text).width;
};
